import { Params } from '@angular/router';

// import {PropsMapping} from '@shared/interfaces';
import {Model} from './model';
import {ConfigModel} from './config.model';

// const propsMapping: PropsMapping = {
const propsMapping: Params = {
  id: 'eventId',
  tournamentCategoryId: 'tournamentCategoryId',
  parentId: 'parentId',
  title1: 'title1',
  title2: 'title2',
  startDate: 'startDate',
  endDate: 'endDate',
  sort: 'sort',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',

  config: 'config',
};

export class EventModel extends Model {
  tournamentCategoryId!: number;
  parentId!: number;
  title1!: string;
  title2!: string;
  startDate!: Date;
  endDate!: Date;
  sort!: number;
  status!: string;
  createdAt!: Date;
  updatedAt!: Date;

  config?: ConfigModel;
  children?: EventModel[];

  static getInstance(data: Params): EventModel {
    const model = new EventModel();
    for (const prop in propsMapping) {
      if (
        data[propsMapping[prop]] === undefined ||
        data[propsMapping[prop]] === null
      ) {
        continue;
      }

      if (prop === 'config') {
        (model as Params)[prop] = ConfigModel.getInstance(data[propsMapping[prop]]);
      } else {
        (model as Params)[prop] = data[propsMapping[prop]];
      }
    }
    return model;
  }
}
